import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import BasicModal from '../../components/Modal.js';
import { styled } from './TemplateSave.js';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid } from '@mui/x-data-grid';
import { TemplateApi } from '../../apis/index';

const TemplateUpdate = (props) => {
  const id = props.match.params.id;
  const [template, setTemplate] = useState([]);
  const [useHospital, setHospitals] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const templateKey = ['scaffoldProperty', 'scaffoldMaterial', 'kitInfo'];
  const inputRef = useRef(null);
  const [copyTemplate, setCopyTemplate] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const columns = [
    {
      field: 'hospital_name',
      headerName: 'Hospital Name',
      width: 480,
    },
    {
      field: 'hospital_code',
      headerName: 'Country Code',
      width: 200,
    },
    {
      field: 'wound_type',
      headerName: 'Wound Type',
      width: 200,
    },
  ];

  const addColumnsData = (columns) => {
    const addDesign = {
      sortable: false,
      headerAlign: 'center',
      align: 'center',
    };
    for (let i in columns) {
      columns[i] = { ...columns[i], ...addDesign };
    }
    return columns;
  };

  const addRowsData = (rows) => {
    return rows.map((row, index) => ({
      id: index + 1,
      ...row,
    }));
  };

  const getTemplateInfo = async () => {
    const templateRes = await TemplateApi.getTemplateByName(id);
    const hospitalRes = await TemplateApi.getTemplateHospital(id);
    setTemplate(templateRes.data);
    setHospitals(hospitalRes.data.hospitals);
  };
  const getTemplateList = async () => {
    // const res = await TemplateApi.getTemplate();
    // console.log(res);
    // setTemplateList(res.data);
  };
  useEffect(() => {
    getTemplateInfo();
    getTemplateList();
  }, []);

  const templateName = useMemo(() => {
    return templateList.map((template) => {
      return { label: template.templateName, id: template.id };
    });
  }, [templateList]);

  const selectOldTemplate = async (e, value) => {
    // if (value.label.toString().trim().length === 0) {
    //   return;
    // }
    // const res = await TemplateApi.getTemplate(
    //   `admin/kit/kitMeta/select/${value.id}`,
    // );
    // console.log(res.data);
    // setTemplate({
    //   ...template,
    //   scaffoldProperty: res.data.scaffoldProperty,
    //   kitInfo: res.data.kitInfo,
    //   scaffoldMaterial: res.data.scaffoldMaterial,
    // });
  };

  const changeTitleorMemo = (e) => {
    setTemplate({
      ...template,
      [e.target.name]: e.target.value,
    });
  };

  const select = (e) => {
    e.target.select();
  };

  const changeValue = (e) => {
    const firstValue = e.target.name.split('.');
    if (firstValue[1] === 'version' || firstValue[1] === 'invivoSpec') {
      setTemplate((prev) => ({
        ...prev,
        [firstValue[0]]: {
          ...prev[firstValue[0]],
          [firstValue[1]]: e.target.value,
        },
      }));
    } else if (
      /^(-?\d+\.\d*|-?\d*|-)$/.test(e.target.value) ||
      e.target.value === ''
    ) {
      setTemplate((prev) => ({
        ...prev,
        [firstValue[0]]: {
          ...prev[firstValue[0]],
          [firstValue[1]]: e.target.value,
        },
      }));
    }
  };

  const saveTemplate = async (e) => {
    // e.preventDefault();
    // if (
    //   template.templateName === null ||
    //   template.templateName.trim().toString().length === 0
    // ) {
    //   inputRef.current.focus();
    //   showModalWithContent('템플릿 이름이 없습니다.');
    //   handleModalOpen();
    //   return;
    // }
    // let reg = /[`ㅤ~!@#$%^&*()|+\=?;:'"<>\{\}\[\]\\\/ ]/gim;
    // const templateTrimName = template.templateName.replace(reg, '');
    // setTemplate({
    //   ...template,
    //   templateName: templateTrimName,
    // });

    // const res = await TemplateApi.saveTemplate(
    //   'admin/kit/kitMeta/update',
    //   JSON.stringify({ ...template, templateName: templateTrimName }),
    // );
    // //템플릿 등록 성공
    // if (res !== null && res.statusCode === 200) {
    //   props.history.push('/template');
    // }
    // //템플릿 이름 중복일때
    // else if (res !== null && res.statusCode === 314) {
    //   inputRef.current.focus();
    //   showModalWithContent(
    //     `${template.templateName}와/과 이름이 같은 템플릿이 있습니다.`,
    //   );
    //   handleModalOpen();
    // }
    // //템플릿 등록 실패
    // else {
    //   showModalWithContent(`${template.templateName} 등록 실패`);
    //   handleModalOpen();
    // }
  };
  //KST 시간 계산
  let koDate = '';
  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    koDate = date.toISOString().replace('T', ' ').substring(0, 19);
    return koDate.toString();
  };

  //Template 사용중인 병원 링크
  const handleRowSelection = (e) => {
    window.open('/updateHospitalAdmin/' + e.row.hospital_id);
  };

  //Modal
  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => setModalStatus(false);

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);
  //

  return (
    <div>
      <style>
        {/* Focus */}
        {`
          *:focus {
            outline: none;
          }
        `}
      </style>
      <Form onSubmit={saveTemplate} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <Form.Group style={{ marginBottom: '30px' }}>
          <Form.Label>Template Name</Form.Label>
          <Form.Control
            ref={inputRef}
            type="text"
            placeholder="Template Name"
            onChange={changeTitleorMemo}
            name="templateName"
            required
            autoComplete="off"
            value={template.templateName}
            maxLength={50}
            disabled={true}
          />
        </Form.Group>

        {/* update기능 구현할 때 필요
      <Form.Group style={{ marginTop: '30px' }}>
        {templateListName(templateList)}
        <Autocomplete
          disablePortal
          options={templateName}
          onChange={selectOldTemplate}
          sx={{ width: '100%' }}
          renderInput={(params) => (
            <TextField {...params} label="Copy Template" />
          )}
          required
        />
      </Form.Group> */}

        {templateKey.map((property, index) => {
          return (
            <div>
              {template[property] ? (
                <div>
                  <p style={styled.titleText}>{property}</p>
                  <div style={styled.largeBox}>
                    {Object.entries(template[property]).map(([key, value]) => {
                      return (
                        <div style={styled.smallBox}>
                          <div style={styled.inputText}>
                            <div>{key}</div>
                          </div>
                          <input
                            style={styled.inputBox}
                            defaultValue={value}
                            name={key}
                            readOnly
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    ...styled.largeBox,
                    display: 'flex',
                    padding: '30px 0px',
                  }}
                >
                  <CircularProgress />
                </div>
              )}
            </div>
          );
        })}
        <Form.Group>
          <Form.Label style={styled.titleText}>Memo</Form.Label>
          <textarea
            name="memo"
            style={{ ...styled.memo }}
            value={template.memo}
            onChange={changeTitleorMemo}
            disabled={true}
          ></textarea>
        </Form.Group>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {template.insertDate && (
                <div>{setDate(template.insertDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {template.insertId}
            </div>
          </Form.Group>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {template.insertDate && (
                <div>{setDate(template.modifyDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {template.modifyId}
            </div>
          </Form.Group>
        </div>
        <Form.Group>
          <Form.Label style={styled.titleText}>
            List of Hospitals in Use
          </Form.Label>

          <div style={{ height: 370, width: '100%' }}>
            <DataGrid
              rows={addRowsData(useHospital)}
              columns={addColumnsData(columns)}
              autoPageSize={true}
              disableColumnMenu
              onRowClick={handleRowSelection}
              // style={{cursor: 'pointer'}}
              sx={{
                boxShadow: 2,
                border: 2,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
            />
          </div>
        </Form.Group>

        <Grid container direction="row" justifyContent="center">
          <button
            type="button"
            onClick={() => {
              props.history.goBack();
            }}
          >
            Back
          </button>
          {/* <Button color="primary" type="submit">
            Save
          </Button> */}
          {/* <Button color="secondary" onClick={() => {}}>
          Delete
        </Button> */}
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
      </div>
    </div>
  );
};

export default TemplateUpdate;
